// Compute the ROI that has accrued on-chain-eligibly for an investment but
// has NOT yet been credited (waiting for the next accrueUser() / claim call).
//
// Mirrors the on-chain math in _accrueUserAll:
//   missed = curCutoff - inv.lastCutoffIndex, capped at MAX_CUTOFFS
//   gross  = amountUSDT * dailyROIBps * missed / (2 * 10000)
//   capped by (bucketCap - bucketEarned)
//
// Notes:
//  - We don't downgrade to flexible tier if the PinkSale lock is broken —
//    we'd need to hit the lock viewer for that. Displayed value is a
//    best-case estimate under normal (test mode / valid lock) conditions.
//  - Leader-type investments (2) and closed/withdrawn positions return 0.
const MAX_CUTOFFS = 4000n;

export const computeInvPending = (inv, currentCutoffIndex) => {
  if (!inv) return 0n;
  if (!inv.active || inv.principalWithdrawn) return 0n;
  if (Number(inv.investmentType) === 2) return 0n;

  const cur = BigInt(currentCutoffIndex || 0);
  const last = BigInt(inv.lastCutoffIndex || 0);
  if (cur <= last) return 0n;

  let missed = cur - last;
  if (missed > MAX_CUTOFFS) missed = MAX_CUTOFFS;

  const amt = BigInt(inv.amountUSDT || 0);
  const bps = BigInt(inv.dailyROIBps || 0);
  const gross = (amt * bps * missed) / (2n * 10000n);

  const cap = BigInt(inv.bucketCapUSDT || 0);
  const earned = BigInt(inv.bucketEarnedUSDT || 0);
  const remaining = cap > earned ? cap - earned : 0n;

  return gross > remaining ? remaining : gross;
};

export const sumInvPending = (investments, currentCutoffIndex) => {
  if (!investments || !investments.length) return 0n;
  let total = 0n;
  for (const inv of investments) total += computeInvPending(inv, currentCutoffIndex);
  return total;
};
